import * as React from "react";
import { useBarcode } from '@createnextapp/react-barcode';
export var Barcode = function (props) {
    var value = props.value;
    var inputRef = useBarcode({
        value: value,
        options: {
            background: '#fff',
            format: "CODE128B",
            height: 20,
            width: 1,
            fontSize: 12,
        },
    }).inputRef;
    return React.createElement("svg", { ref: inputRef });
};
//# sourceMappingURL=Barcode.js.map